import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler } from "reactstrap";
import { blogItems, otherPagesItems } from "../../Data/Navbar/navbar";

const DemoNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Navbar expand='lg' className='theme-nav'>
      <Container className='d-flex align-items-center'>
        <NavbarBrand href={`${process.env.PUBLIC_URL}/`}>
          <img src='assets/images/logo.png' alt='logo' />
        </NavbarBrand>
        <NavbarToggler className='navbar-toggler' type='button' data-toggle='collapse' data-target='#mainmenu' aria-expanded='false' aria-label='Toggle navigation'>
          <span className='navbar-toggler-icon' onClick={toggle}>
            <i className='fa fa-align-justify' aria-hidden='true'></i>
          </span>
        </NavbarToggler>
        <Collapse className='collapse navbar-collapse justify-content-end' id='mainmenu' isOpen={isOpen}>
          <ul className='navbar-nav ml-auto' id='mymenu'>
            <li className='nav-item'>
              <Link className='nav-link' to={`${process.env.PUBLIC_URL}/`}>
                Home
              </Link>
            </li>
            <li className='nav-item dropdown'>
              <Link href={null} className='nav-link dropdown-toggle' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>
                Blog
              </Link>
              <ul className='dropdown-menu'>
                {blogItems.map((item, i) => {
                  return (
                    <li className='nav-item' key={i}>
                      <a className='nav-link' href={item.link}>
                        {item.label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </li>
            <li className='nav-item dropdown'>
              <Link className='nav-link dropdown-toggle' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>
                Other Page
              </Link>
              <ul className='dropdown-menu'>
                {otherPagesItems.map((item, i) => {
                  return (
                    <li className='nav-item' key={i}>
                      <a className='nav-link' href={item.link}>
                        {item.label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </li>
          </ul>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default DemoNav;
